import React from 'react';
import './Services.css';

const Services = ({ onServiceSelect, activeService }) => {
  const services = [
    {
      number: '01',
      title: 'Everyday Digital Setup',
      description: 'Move from registers and scattered notes to simple digital tools for everyday work.',
      groupId: 'everyday-digital',
      colorClass: 'red',
      detailLink: '#everyday-digital-setup'
    },
    {
      number: '02',
      title: 'AI-Enabled Workflow Automation',
      description: 'Redesign and automate key workflows so steps connect smoothly, manual repetition drops, and work moves faster.',
      groupId: 'workflow-automation',
      colorClass: 'yellow',
      detailLink: '#ai-workflow-automation'
    },
    {
      number: '03',
      title: 'Business Transformation & AI Makeover',
      description: 'From legacy operations to fully digital, integrated, and AI-enabled business maturity.',
      groupId: 'business-transformation',
      colorClass: 'red',
      detailLink: '#business-transformation-ai'
    },
    {
      number: '04',
      title: 'Creative Strategy & Brand Visibility',
      description: 'From low visibility to strong brand presence backed by clear messaging and creative impact.',
      groupId: 'creative-strategy',
      colorClass: 'yellow',
      detailLink: '#creative-strategy-brand'
    }
  ];

  const selectService = (groupId) => {
    window.OwleyesAnalytics?.track('service_select', { service_id: groupId });
    onServiceSelect(groupId);
    if (window.innerWidth <= 768) {
      requestAnimationFrame(() => requestAnimationFrame(() => {
        document.getElementById('solutions')?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      }));
    }
  };
  return (
    <section className="services section" id="services" aria-labelledby="services-title">
      <div className="container">
        <div className="services-header">
          <h2 id="services-title">How we help<span>.</span></h2>
          <p>Four ways to move your business forward.<br />Select the support you need.</p>
        </div>
        <div className="services-grid" aria-label="Choose a service">
          {services.map(service => (
            <button type="button" key={service.groupId} className={`service-card ${activeService === service.groupId ? 'active' : ''} ${service.colorClass}`} onClick={() => selectService(service.groupId)} aria-pressed={activeService === service.groupId} aria-controls="solutions">
              <span className="service-number">{service.number}<span aria-hidden="true">{activeService === service.groupId ? '↘' : '↗'}</span></span>
              <span className="service-title">{service.title}</span>
              <span className="service-description">{service.description}</span>
              <span className="service-detail-link">{activeService === service.groupId ? 'Selected — solutions below' : 'View solutions →'}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Services;
